import { MediaText } from 'editor/src/store/design/types';
import updateTextPropertiesWithoutRender from 'editor/src/store/design/util/updateTextPropertiesWithoutRender';
import isFontFileLoaded from 'editor/src/store/fonts/utils/isFontFileLoaded';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import applyToSelectedMediaTypeOperation from './applyToSelectedMediaTypeOperation';

/**
 * GAPI-61892: turns the fixed frame of the selected texts on or off. Turning it on keeps
 * the frame exactly as it is now — the author then drags it to the size the layout needs.
 * Turning it off lets the frame grow back to the text, as before.
 */
const setTextFixedFrameOperation = (on: boolean) => (dispatch: ThunkDispatch) => {
  dispatch(
    applyToSelectedMediaTypeOperation('text', function setTextFixedFrame(element: MediaText) {
      if (!!element.extra.fixedFrame === on) {
        return undefined;
      }
      const elementUpdate: Partial<MediaText> = {
        extra: { ...element.extra, fixedFrame: on ? true : undefined },
      };
      // Without the font's metrics (protected uploaded fonts are never loaded here) the
      // text cannot be measured, so the frame keeps its size rather than collapse.
      if (!on && isFontFileLoaded(element.extra.fontFamily)) {
        updateTextPropertiesWithoutRender(element, elementUpdate, undefined);
      }
      return elementUpdate;
    }),
  );
};

export default setTextFixedFrameOperation;
